<!-- src/components/Footer.vue -->
<template>
    <div class="footer mt30">
      <div class="wrap1200 clearfix">
        <div class="footNav fl">
          <dl>
            <dt>数据服务</dt>
            <dd><a href="#">开奖公告</a></dd>
            <dd><a href="#">走势图</a></dd>
            <dd><a href="#">资讯</a></dd>
          </dl>
          <dl>
            <dt>分析预测</dt>
            <dd><a href="#">专家推荐</a></dd>
          </dl>
          <dl>
            <dt>服务与支持</dt>
            <dd><a href="#">下载</a></dd>
            <dd><a href="#">帮助中心</a></dd>
          </dl>
        </div>
        <div class="footRight fr">
          <ul>
            <li>
              <div class="contactInfo">
                <div class="phone">
                  <div class="phoneIcon">
                    <i class="el-icon-phone"></i>
                  </div>
                  <div class="txt">
                    <h6>18832576178</h6>
                    <p>服务时间09:00-18:00</p>
                  </div>
                </div>
                <div class="butler">
                  <a href="javascript:;">微信联系管家</a>
                  <div class="butlerEwm">
                    <img src="../assets/customerEwm.png">
                    <p>如有疑问<br>请添加管家微信咨询</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <img src="../assets/appQR.png">
              <p>购彩网App</p>
            </li>
            <li>
              <img src="../assets/officialQR.png">
              <p>购彩网公众号</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="copyRightWrap">
        <div class="wrap1200">
          <div class="copyRight">
            <span>Copyright © 2022 购彩网版权所有</span>
              <span class="ml10">唐山瑞喜科技有限公司</span>   
              <span class="ml10 mr15" style="color: rgba(255,255,255,.5);">ICP证：冀ICP备2024086501号-2</span>
              <a><img src="../assets/polic.png" alt="" style="height: 20px;display: block;"></a>
              <span class="ml5 mr10">
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: rgba(255,255,255,.5);">
                  冀公网安备13020702000353号
                </a>
              </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Footer',
    data(){
      return {
        
      }
    },
    methods:{}
  }
  </script>
  
  <style scoped>
  .footer {
    background: #282F3C;
    border-top: 4px solid #EA4747;
  }
  .mt30{
    margin-top: 30px;
  }
  .wrap1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }
  .clearfix:after{
    clear:both;
    content:".";
    display:block;
    height:0;
    visibility:hidden
  }
  .clearfix{
    zoom:1
  }
  .footNav {
    padding: 20px 0 50px;
  }
  .fl {
    float: left;
    display: inline;
  }
  .fr {
    float: right;
    display: inline;
  }
  .footNav dl {
    float: left;
    width: 175px;
  }
  .footNav dl dt {
    font-size: 14px;
    color: #fff;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .footNav dl dd {
    line-height: 30px;
  }
  .footNav dl dd a {
    opacity: .5;
    color: #fff;
  }
  .footRight {
    padding: 30px 0;
    font-size: 0;
    text-align: right;
  }
  .footRight ul li {
    text-align: center;
    padding: 0 20px;
    display: inline-block;
    vertical-align: top;
    font-size: 12px;
  }
  .contactInfo {
    text-align: right;
    padding-top: 5px;
  }
  .contactInfo .phone {
    display: flex;
    align-items: center;
  }
  .contactInfo .phoneIcon {
    width: 42px;
    height: 42px;
    font-size: 20px;
    margin-right: 13px;
    color: #FFFFFF;
    background: #424854;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .contactInfo .txt h6 {
    font-size: 18px;
    color: #fff;
    font-weight: normal;
  }
  .footRight ul li p {
    color: #fff;
    opacity: .5;
  }
  .contactInfo .butler {
    position: relative;
    display: inline-block;
    width: 120px;
    height: 40px;
    background: rgba(255, 255, 255, .07);
    border-radius: 8px;
    margin-top: 13px;
  }
  .contactInfo .butler a {
    display: block;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    font-weight: 800;
    border-radius: 8px;
  }
  .contactInfo .butler a:hover {
    background: #EA4747;
  }
  .contactInfo .butler:hover .butlerEwm{ 
    opacity: 1;
    visibility: visible;
    margin-bottom: 7px;
    transition: opacity 0.5s ease-in-out;
  }
  .butlerEwm {
    opacity: 0;
    visibility: hidden;
    padding: 20px 0 15px;
    position: absolute;
    left: 0;
    bottom: 100%;
    margin-bottom: 0;
    width: 180px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 10px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    text-align: center;
  }
  .butlerEwm img {
    width: 100px;
    height: 100px;
    vertical-align: top;
  }
  .footRight .butlerEwm p {
    font-size: 14px;
    line-height: 20px;
    color: #333;
    opacity: 1;
  }
  .footRight ul li > img {
    margin: 0 auto;
    display: block;
    width: 100px;
    height: 100px;
    margin-bottom: 10px;
  }
  .footRight ul li p {
    color: #fff;
    opacity: .5;
  }
  .copyRightWrap {
    border-top: 1px solid rgba(255, 255, 255, .05);
  }
  .copyRight {
    height: 60px;
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, .5);
  }
  .ml10 {
    margin-left: 10px;
  }
  .ml5 {
    margin-left: 5px;
  }
  .mr15 {
    margin-right: 15px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/Footer.vue